import { render, staticRenderFns } from "./stage.vue?vue&type=template&id=0e6ed7e2&scoped=true&"
import script from "./stage.vue?vue&type=script&lang=js&"
export * from "./stage.vue?vue&type=script&lang=js&"
import style0 from "./stage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./stage.vue?vue&type=style&index=1&id=0e6ed7e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6ed7e2",
  null
  
)

export default component.exports